// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k7-0";
export var buttonContainer = "_k7-3";
export var cancelButton = "_k7-4";
export var headerSection = "_k7-6";
export var headerTitle = "_k7-9";
export var messageSideLeft = "_k7-1";
export var messageSideRight = "_k7-2";
export var orderNumberContainer = "_k7-7";
export var orderNumberLabel = "_k7-8";
export var submitButton = "_k7-5";